import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
// import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import EducationImg from "./EducationImg";
import { competitiveSites } from "../../portfolio";
import "./EducationComponent.css";
import { Fade } from "react-reveal";
import Resume from "./Resume";

class Education extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="education-main">
        <Header theme={this.props.theme} />
        <div className="basic-education">
          <Fade bottom duration={2000} distance="40px">
            <div className="heading-div">
              <div className="heading-img-div">
                <EducationImg theme={theme} />
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.orange }}>
                  Experience &#38; Education
                </h1>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  {(() => {
                    const startDate = new Date("2021-07-01");
                    const currentDate = new Date();
                    const diffInMonths =
                      (currentDate.getFullYear() - startDate.getFullYear()) *
                        12 +
                      (currentDate.getMonth() - startDate.getMonth());
                    const years = Math.floor(diffInMonths / 12);
                    const months = diffInMonths % 12;
                    return `${years} Years ${months} Months Experience`;
                  })()}
                </h3>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  B.Tech(Hons.) in Computer Science & Engg
                </h3>
                <h3 className="heading-sub-text" style={{ color: theme.text }}>
                  TCS NQT (2019) Qualified (Ninja Profile)
                </h3>
                <CompetitiveSites logos={competitiveSites.competitiveSites} />
              </div>
            </div>
          </Fade>
          <Resume />
          <Certifications theme={this.props.theme} />
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Education;
